import script from "./CollectivitesDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesDashboard.vue?vue&type=style&index=0&id=43ebdd86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ebdd86"]])

export default __exports__